
import { FileDocument, SavedQuery } from '@/model';
import Vue from 'vue';
import QueryList from '@/components/QueryList.vue';
import SelectionClauseEditor from '@/components/SelectionClauseEditor.vue';
import labels from '@/store/labels';
import realms from '@/store/realms';

export default Vue.extend({
  name: 'SelectionQueryEditor',
  components: {
    QueryList,
    SelectionClauseEditor,
  },

  props: {
    value: { type: Object as () => SavedQuery, required: true },
    loading: { type: Boolean, default: false },
    documents: { type: Array as () => FileDocument[], default: () => [] },
    queries: { type: Array as () => SavedQuery[], default: () => [] },
  },

  data() {
    return {
      saveDialog: false,
      listDialog: false,
      helpDialog: false,
      advancedMode: localStorage.getItem('advancedMode') === 'true',
      edit: { ...this.value },
    };
  },

  computed: {
    labels() {
      return labels.state.labels.filter((l) => l.selectable);
    },
    realms() {
      return realms.state.realms;
    },
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        this.edit = { ...this.value };
      },
    },
  },

  methods: {
    toggleAdvancedMode() {
      this.advancedMode = !this.advancedMode;
      localStorage.setItem('advancedMode', String(this.advancedMode));
    },
    input() {
      this.$emit('input', this.edit);
    },
    save() {
      this.$emit('save', this.edit);
      this.saveDialog = false;
    },
    saveAsNew() {
      this.$emit('save', {
        id: 0, name: this.edit.name, clause: this.edit.clause, shared: this.edit.shared,
      });
      this.saveDialog = false;
    },
    click(query: SavedQuery) {
      this.$emit('changeQuery', query);
      this.listDialog = false;
    },
    reset() {
      this.$emit('reset');
    },
  },

});
